import * as React from "react";
import {Post} from "../types/Post";
import {StaticImage} from "gatsby-plugin-image";
import * as styles from "../styles/post.module.scss";

interface PostImageProps {
	post: Post;
}

export const PostImage: React.FC<PostImageProps> = ({post}) => {
	if (post.frontmatter.ogImage && post.frontmatter.ogImage.publicURL) {
		return (
			<img
				src={post.frontmatter.ogImage.publicURL}
				alt={post.frontmatter.title}
				className="w-full h-auto"
			/>
		);
	}

	return (
		<StaticImage
			alt="Logo"
			src="../images/logo.png"
			className={styles.postImage}
		/>
	);
};
